

import React, { useContext } from 'react';
import '../../../styles/content.css';
import NewsContentSide from "./newsContentSide.jsx";
import NewsContentMain from './newsContentMain.jsx';
import RelatedSigmentNews from './relatedSigmentNews.jsx';
import { DeviceContext } from '../index.jsx';

const NewsContent = ({ data }) => {

  const isSSR = data?.[0]?.contentPageData || {};
  let ssrContentId = isSSR?.ssrContentId
  let ssrCatId = isSSR?.ssrCatId
  const { mobile } = useContext(DeviceContext)

  const initialContent = isSSR ? { contentData: isSSR, loading: false, }
    : { contentData: {}, error: null, loading: true };

  const { singleNews, 
    moreNews,
  } = initialContent.contentData;
  // const { singleNews, prevNews, nextNews,
  //   moreNews,
  // } = initialContent.contentData;

  return (
    <div className='news-content-page-wrapper'>

      <div className='news-content-loader'>

        {/* <NewsContentMain mobile={mobile} ssrContentId={ssrContentId} ssrCatId={ssrCatId} singleNews={singleNews} prevNews={prevNews} nxtNews={nextNews} /> */}
        <NewsContentMain mobile={mobile} ssrContentId={ssrContentId} ssrCatId={ssrCatId} singleNews={singleNews}  />
        {!mobile && <NewsContentSide ssrContentId={ssrContentId} ssrCatId={ssrCatId}
          moreNews={moreNews} 
        />}
      </div>

      <RelatedSigmentNews ssrCatId={ssrCatId} />

    </div>
  );
};

export default NewsContent;
